import { apiVersion, dataset, projectId, studioUrl } from '@/sanity/lib/api'
import { createClient } from 'next-sanity'

// stega 비활성화: Visual Editing은 안되지만 Preview는 정상 작동
const ENABLE_STEGA = false

export const client = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: false,
  perspective: 'published',
  ...(ENABLE_STEGA
    ? {
        stega: {
          studioUrl,
          logger: console,
          filter: props => props.filterDefault(props),
        },
      }
    : {}),
})

if (ENABLE_STEGA) {
  console.warn(
    'This template is using stega to embed Content Source Maps, see more information here: https://www.sanity.io/docs/loaders-and-overlays#26cf681fadd4'
  )
} else {
  console.warn('Stega is disabled - visual editing will not work')
}
